import { useEffect, useRef, useState } from 'react';

// Bumps a counter each time `value` makes a transition `shouldBump` recognises,
// so a one-shot animation can key off the count and replay only on a genuine
// transition, never on mount or a no-change re-render. `enabled` gates it (e.g.
// off under prefers-reduced-motion). Pass a stable (module-level) `shouldBump`.
// Shared by the chip's arrival pop, the panel row's arrival wash, and the toolbar
// pill's kickoff ring.
export function useTransitionCounter<T>(
  value: T,
  shouldBump: (previous: T | null, next: T) => boolean,
  enabled: boolean,
): number {
  const previous = useRef<T | null>(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (enabled && shouldBump(previous.current, value)) {
      setCount((c) => c + 1);
    }
    previous.current = value;
  }, [value, enabled, shouldBump]);

  return count;
}
